import React, {useState} from 'react'

import './bookingconfirmation.css'
import {timezone, urlJoan, versionApi, generateToken} from '../../BookingRoom.js'
import BookingConfirmed from './BookingConfirmed/BookingConfirmed.js'

import {Button, notification} from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';
import reqwest from 'reqwest'

const dayjs = require('dayjs')
var utc = require('dayjs/plugin/utc')
var timezoneJS = require('dayjs/plugin/timezone')

dayjs.extend(utc)
dayjs.extend(timezoneJS)

const BookingConfirmation = ({handleBack, values, roomBookedId, setSearching}) => {
	const [loading, setLoading] = useState(false)
	const [confirmedBooking, setConfirmedBooking] = useState(false)
	const [api, contextHolder] = notification.useNotification();
	const [errorButton, setErrorButton] = useState(false)
	
	const openNotification = () => {
		api.error({
		  message: 'Ups!',
		  description: 'Parece que alguien ha reservado la sala antes que tú...',
		});
	};
	
	const handleBookEvent = async () => {
		setLoading(true)
		const token = await generateToken(urlJoan)
		
		const dS = dayjs.tz(dayjs(values.date).format('YYYY-MM-DD') + 'T' + dayjs(values.time[0]).format('HH:mm'), 'Europe/Madrid')
		const dE =  dayjs.tz(dayjs(values.date).format('YYYY-MM-DD') + 'T' + dayjs(values.time[1]).format('HH:mm'), 'Europe/Madrid')
		
		const params = {
			source : roomBookedId.id,
			start : dS.format(),
			end : dE.format(),
			organizer : values.email,
			title : values.description, 
			timezone : timezone,
			auto_confirm: true
		  }
		try {
			await reqwest({
		  	url: urlJoan + versionApi + 'events/book/',
		  	method: 'POST',
		  	headers: {
				Authorization: 'Bearer ' + token,
		  	},
		  	data: params,
		  	type: 'json',
		  	crossOrigin: true,
		  	error: function(err) {
				openNotification()
				setLoading(false)
		  	},
			}).then(data => {
				setLoading(false)
				setConfirmedBooking(true)
			})
		} catch(e) {
			setErrorButton(true)
		}
	  }
	  
	  const handleButtonBack = () => {
		  if(errorButton) {
			  setSearching(true)
		  } else {
			  handleBack()
		  }
	  }
	  
	return (
		<div style={{height: '100%'}}>
			{
				confirmedBooking ?
					<BookingConfirmed setSearching={setSearching}/>
				:
				<>
				{contextHolder}
				<div className="backbtn" onClick={handleButtonBack}>
					<ArrowLeftOutlined />
				</div>
				<div className="bookconfirmwrap">
					<div className="bookconfirmtitle" style={{textAlign: 'center'}}>
						<p>DATOS DE LA RESERVA</p>
					</div>
					<div className="bookconfirminfo">
						<div className="bookconfirmitem">
							<p>SALA</p>
							<span>{roomBookedId.name}</span>
						</div>
						<div className="bookconfirmitem">
							<p>FECHA Y HORA</p>
							<span>{dayjs(values.date).format('DD/MM/YY')} de {dayjs(values.time[0]).format('HH:mm')} a {dayjs(values.time[1]).format('HH:mm')}</span>
						</div>
						<div className="bookconfirmitem">
							<p>MOTIVO</p>
							<span>{values.description}</span>
						</div>
						<div className="bookconfirmitem">
							<p>EMAIL</p>
							<span>{values.email}</span>
						</div>
					</div>
				</div>
				<div className="buttonCheckAvailable">
					{
						errorButton ?
							<Button onClick={() => setSearching(true)}>VOLVER</Button>
						:
							<Button onClick={handleBookEvent} loading={loading}>CONFIRMAR</Button>
					}
				</div>
				</>
			}
		</div>
	)
}


export default BookingConfirmation